import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { State } from './types';
import { endpoints, baseQuery } from 'utils/api/endpoints';

export const initialState: State = {};

const slice = createSlice({
  name: 'currencies',
  initialState,
  reducers: {},
});

export const api = createApi({
  reducerPath: 'currenciesApi',
  baseQuery,
  tagTypes: ['Currencies'],
  endpoints: builder => ({
    getCurrencies: builder.query({
      query: () => ({
        url: endpoints.CURRENCIES,
        method: 'GET',
      }),
      providesTags: ['Currencies'],
    }),
    getAllCurrency: builder.query({
      query: () => ({
        url: endpoints.CURRENCIES + '/all',
        method: 'GET',
      }),
      providesTags: ['Currencies'],
    }),
    addCurrency: builder.mutation({
      query: data => ({
        url: endpoints.CURRENCIES + '/add',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Currencies'],
    }),
    deleteCurrency: builder.mutation({
      query: data => ({
        url: endpoints.CURRENCIES + '/delete',
        method: 'DELETE',
        body: data,
      }),
      invalidatesTags: ['Currencies'],
    }),
    updateCurrency: builder.mutation({
      query: data => ({
        url: endpoints.CURRENCIES + '/update',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Currencies'],
    }),
    getLatestExchangeRate: builder.query({
      query: () => ({
        url: endpoints.CURRENCIES + '/exchange-rates/latest',
        method: 'GET',
      }),
    }),
    getLastUpdatedExchangeRate: builder.query({
      query: () => ({
        url: endpoints.CURRENCIES + '/exchange-rates/last-updated',
        method: 'GET',
      }),
    }),
  }),
});

export const { actions: currencyActions } = slice;

export const useCurrenciesSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    actions: currencyActions,
    useGetCurrenciesQuery: api.useLazyGetCurrenciesQuery,
    useGetAllCurrencyQuery: api.useLazyGetAllCurrencyQuery,
    useAddCurrencyMutation: api.useAddCurrencyMutation,
    useDeleteCurrencyMutation: api.useDeleteCurrencyMutation,
    useUpdateCurrencyMutation: api.useUpdateCurrencyMutation,
    useGetLatestExchangeRateQuery: api.useLazyGetLatestExchangeRateQuery,
    useGetLastUpdatedExchangeRateQuery:
      api.useLazyGetLastUpdatedExchangeRateQuery,
  };
};
